<template>
	<section class="page">
		<due-tabs v-model="activeName"></due-tabs>
		<div class="content-box">
			<edit-order></edit-order>
		</div>
	</section>
</template>

<script>
import EditOrder from "@/views/Order/subs/EditOrder.vue";
import TabPage from "@/mixins/TabPage.js";
import DueTabs from "@/views/Order/widgets/DueTabs.vue";

export default {
	mixins: [TabPage],
	components: {
		EditOrder,
		DueTabs,
	},
	data() {
		return {
			activeName: "build",
			fakeTabs: {
				indexs: { name: "Order-Index" },
				waitpay: { name: "Order-WaitPay" },
				due: { name: "Order-IndexDue" },
			},
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
